// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i__M","colBig":"styles_colBig__37PZp","colSmall":"styles_colSmall__2sVCN"};